module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom1 footer-a"
  }, [_c('div', {
    staticClass: "wh1200"
  }, [_c('div', {
    staticClass: "footer-content1 footer-border"
  }, [_c('a', {
    attrs: {
      "href": "http://www.spr-atm.com/",
      "target": "_black"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/spr_logo.png"),
      "alt": "前海高扬"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "footer-content1 footer-content2 footer-border"
  }, [_c('img', {
    staticClass: "footer-img1",
    attrs: {
      "src": require("../../assets/icon_phone.png"),
      "alt": "phone"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "footer-font2"
  }, [_vm._v("服务热线\n        "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "footer-font1"
  }, [_vm._v("0755-82405890")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-content1 footer-content2 footer-border"
  }, [_c('span', {
    staticClass: "footer-font3"
  }, [_vm._v("地址：西丽街道沙河西路3011号白沙新兴产业园1号楼 "), _c('br'), _vm._v("Copyright ©\n        深圳前海高扬科技有限公司\n        "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("\n          粤ICP备19007655号\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-content1 footer-content2 footer-border"
  }, [_c('span', {
    staticClass: "footer-font4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon_query.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.kuaidi100.com/sz/",
      "target": "_blank"
    }
  }, [_vm._v("快递查询")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "footer-font4"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon_mail.png"),
      "alt": ""
    }
  }), _vm._v("客服邮箱：\n        "), _c('a', {
    attrs: {
      "href": "mailto:atm8123@spr-atm.com"
    }
  }, [_vm._v("atm8123@spr-atm.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-content1 footer-content2"
  }, [_c('span', {
    staticClass: "footer-img1"
  }, [_c('a', {
    attrs: {
      "href": "http://61.144.227.239:9003/webrecord/form_query.jsp",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon_aq.jpg"),
      "alt": "国际联网备案验证"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "footer-img1"
  }, [_c('a', {
    attrs: {
      "href": "http://61.144.227.239:9002/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon_jb.jpg"),
      "alt": "网上报警"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "footer-img2",
    attrs: {
      "id": "footerEbsBox"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f6f56e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Footer.vue
// module id = 726
// module chunks = 0